<template>
  <div>
    <div class="header">
      <div class="headbar" id="nav">
        <div class="container" id="header">
          <div id="logo">
            <img src="https://cdn2.iconfinder.com/data/icons/flat-sports/1020/Flat_Icon_Designs-04-512.png" alt="">
            <a href="#">Spoctivity </a>
          </div>
          <div id="navigation">
            <div class="nav-left" id="navleft">
              <router-link exact to="/home/dashboard">Dashboard</router-link>
              <router-link exact to="/home/events/1">Events</router-link>
              <router-link exact to="/home/fields">Sportplätze</router-link>
            </div>
            <div class="nav-right">
              <div id="profilnavbar">
                <button class="profilbutton">
                  <a>{{ username }}</a>
                  <div class="avatar">
                    <b-img :src="imageSrc" class="mr-3"/>
                  </div>
                  <svg class="icon">
                    <polyline fill="none" stroke="#708C91" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" stroke-miterlimit="10" points="9 18 15 12 9 6"
                              transform="rotate(0 12 12)"></polyline>
                  </svg>
                </button>
                <div class="dropdown-content" id="myDropdown">
                  <ul class="list">
                    <li>
                      <div @click="toggleFriendSideBar" class="item"><span class="lefticon">
                         <b-icon icon="people"></b-icon>
                            </span>
                        <span class="lefttext"> Freunde</span>
                        <span class="righticon badge" v-show="friendRequestCount > 0">
                            {{ friendRequestCount }}
                          <!--<b-icon icon="app-indicator"></b-icon>-->
                                </span></div>
                    </li>
                    <li>
                      <router-link class="item" to="/home/messages"><span class="lefticon">
                         <b-icon icon="chat"></b-icon>
                            </span>
                        <span class="lefttext"> Nachrichten</span>
                        <span class="righticon">
                                </span></router-link>
                    </li>
                    <li>
                      <router-link class="item" to="/home/profile"><span class="lefticon">
                         <b-icon icon="gear"></b-icon>
                            </span>
                      <span class="lefttext"> Einstellungen</span>
                      <span class="righticon">
                                </span></router-link>
                    </li>
                    <li>
                      <router-link class="item" to="/home/events/create"><span class="lefticon">
                         <b-icon icon="plus-circle"></b-icon>
                            </span>
                        <span class="lefttext">Neues Event erstellen</span>
                        <span class="righticon">
                                </span></router-link>
                      <div class="line">
                        <hr>
                      </div>
                    </li>
                    <li>
                      <a class="item" href="#" v-on:click="logoutClicked">
                            <span class="lefticon">
                               <b-icon icon="door-open"></b-icon>
                            </span>
                        <span class="lefttext"> Ausloggen</span>
                        <span class="righticon">
                                </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div id="canvas" class="sidecanvas" v-on:click="showMobileNav = false"></div>
          <div id="mySidenav" class="sidenav">
          </div>
          <div id="mobilemenu" v-on:click="showMobileNav = true">
            <b-icon icon="list"></b-icon>
          </div>
        </div>
      </div>
    </div>
    <div id="mnav" class="mobile_sidenav">
      <span href="#" class="mobile_sidenav_close" @click="showMobileNav = false">&times;</span>
      <router-link class="item" v-on:click.native="showMobileNav = false" to="/home/dashboard">Dashboard</router-link>
      <router-link class="item" v-on:click.native="showMobileNav = false" to="/home/events/1">Events</router-link>
      <router-link class="item" v-on:click.native="showMobileNav = false" to="/home/events/create">Event erstellen</router-link>
      <router-link class="item" v-on:click.native="showMobileNav = false" to="/home/fields">Felder</router-link>
      <router-link class="item" v-on:click.native="showMobileNav = false" to="/home/friends">Freunde</router-link>
      <router-link class="item" v-on:click.native="showMobileNav = false" to="/home/messages">Nachrichten</router-link>
      <router-link class="item" v-on:click.native="showMobileNav = false" to="/home/profile">Einstellungen</router-link>
      <div class="line">
        <hr>
      </div>
      <a href="#" v-on:click="logoutClicked">Ausloggen</a>
    </div>
    <FriendListSideBar v-bind:show="openFriendSidebar"></FriendListSideBar>
    <b-container>
      <router-view></router-view>
    </b-container>
  </div>
</template>
<script>

import {userService} from "../services/user.service";
import {imageService} from "../services/image.service";
import FriendListSideBar from "@/components/shared/FriendListSideBar";
import {friendService} from "@/services/friend.service";

export default {
  name: 'Home',
  data() {
    return {
      imageSrc: null,
      showMobileNav: false,
      openFriendSidebar: false,
      friendRequestCount: 0
    }
  },
  components: {
    FriendListSideBar
  },
  created() {
    imageService.getImage().then(resp => {
      this.imageSrc = resp.path
    });
    friendService.getFriends().then(res => {
      this.friendRequestCount = res.friendRequests.length;
    });
  },
  methods: {
    logoutClicked() {
      userService.logout();
    },
    toggleFriendSideBar() {
      if(this.openFriendSidebar === false) {
        this.openFriendSidebar = true
      } else {
        this.openFriendSidebar = false
      }
    },
    friendBarClosed() {
      this.openFriendSidebar = false
    }
  },
  computed: {
    username() {
      let user=localStorage.getItem('username')
      if(user.length > 40) {
        return user.slice(0,40) + "..."
      }
      return user
    }
  },
  watch: {
    showMobileNav(val) {
      let nav=document.getElementById('mnav')
      if(val===true) {
        nav.style.width='100%'
      } else {
        nav.style.width='0'
      }
    }
  }
}
</script>

<style scoped>
router-link-exact-active {
  color: indianred;
  cursor: pointer;
}
.header .container {
  padding: 10px 30px;
}
.header {
  margin: 0 0 90px 0;
}
button {
  width: auto;
}
.mobile_sidenav {
  z-index: 999;
  height: 100vh;
}

@media screen and (max-width: 768px) {
  .header {
    margin: 0;
  }
}
</style>
